
import { defineComponent, ref } from 'vue'
import AppPage from '@/AppPage.vue'
import MaintenancePage from '@/MaintenancePage.vue'
import { getPortalConfigFromNuxeo } from './composables/nuxeo'
import { PortalConfigFromNuxeoResponse } from './contracts/api/ResponseContracts'

export default defineComponent(
   {
      components:
      {
         AppPage,
         MaintenancePage
      },
      setup()
      {
         const isMaintenance = ref(false)

         getPortalConfigFromNuxeo(function(response: PortalConfigFromNuxeoResponse)
         {
            isMaintenance.value = response.showMaintenancePage
         })

         // Return data:
         return {
            isMaintenance
         }
      }
   })
